export enum Emphasis {
  NOT_APPLICABLE = 'NOT_APPLICABLE',
  INSIGNIFICANT = 'INSIGNIFICANT',
  INFORMATIVE = 'INFORMATIVE',
  IMPORTANT = 'IMPORTANT',
  CRUCIAL = 'CRUCIAL'
}

export const userInputEmphasis = [
  Emphasis.INSIGNIFICANT,
  Emphasis.INFORMATIVE,
  Emphasis.IMPORTANT,
  Emphasis.CRUCIAL
];

export const isEmphasis = (e: any): e is Emphasis =>
  !!e && Object.values(Emphasis).some((em) => em === e);

export const isDisplayable = (
  emph?: Emphasis
): emph is Emphasis.CRUCIAL | Emphasis.IMPORTANT | Emphasis.INFORMATIVE =>
  emph === Emphasis.CRUCIAL ||
  emph === Emphasis.IMPORTANT ||
  emph === Emphasis.INFORMATIVE;

export const max = (
  e1: Emphasis | undefined,
  e2: Emphasis | undefined
): Emphasis => {
  if (!e1 || !e2) {
    return Emphasis.NOT_APPLICABLE;
  }

  if (e1 === e2) {
    return e1;
  }

  if (e1 === Emphasis.CRUCIAL || e2 === Emphasis.CRUCIAL) {
    return Emphasis.CRUCIAL;
  }
  if (e1 === Emphasis.IMPORTANT || e2 === Emphasis.IMPORTANT) {
    return Emphasis.IMPORTANT;
  }
  if (e1 === Emphasis.INFORMATIVE || e2 === Emphasis.INFORMATIVE) {
    return Emphasis.INFORMATIVE;
  }
  if (e1 === Emphasis.INSIGNIFICANT || e2 === Emphasis.INSIGNIFICANT) {
    return Emphasis.INSIGNIFICANT;
  }
  return Emphasis.NOT_APPLICABLE;
};

export const sortEmphasis = (e1?: Emphasis, e2?: Emphasis): number => {
  if ((!e1 && !e2) || e1 == e2) {
    return 0;
  }
  let i1 = -1;
  let i2 = -1;
  Object.values(Emphasis).forEach((e, i) => {
    if (e === e1) {
      i1 = i;
    }
    if (e === e2) {
      i2 = i;
    }
  });
  return i2 - i1;
};

export interface HasEmphasis {
  emphasis: Emphasis;
}

export const hasEmphasis = (obj: any): obj is HasEmphasis =>
  !!obj && typeof obj === 'object' && 'emphasis' in obj;

export const sortByEmphasis = <T extends HasEmphasis>(
  obj1: T,
  obj2: T
): number => sortEmphasis(obj1.emphasis, obj2.emphasis);

type EmphasisMapper<Arg, T extends HasEmphasis = HasEmphasis> = (arg: Arg) => T;
export const createEmphasisSorter =
  <T extends HasEmphasis, Arg>(mapper: EmphasisMapper<Arg, T>) =>
  (v1: Arg, v2: Arg): number =>
    sortEmphasis(mapper(v1)?.emphasis, mapper(v2)?.emphasis);
